import { ChevronDownIcon } from '@heroicons/react/24/outline';
import type { Locale } from '@xfile/shared';
import { useI18n } from '../i18n';
import { Menu, type MenuOption } from './Menu';
import { Flag } from './Flag';

/**
 * Sélecteur de langue (FR/DE/EN) sous forme de menu déroulant ÉTIQUETÉ : drapeau
 * de la langue courante + nom + chevron (façon maquette de connexion). Chaque
 * option porte aussi son drapeau. Accessibilité déléguée à `Menu` (clavier, clic
 * extérieur, `aria-checked`). Drapeaux = SVG inline décoratifs (le nom porte le sens).
 */
export function LanguageMenu(): React.JSX.Element {
  const { t, locale, setLocale, locales } = useI18n();

  const options: MenuOption<Locale>[] = locales.map((l) => ({
    value: l,
    label: t(`lang.${l}`),
    icon: <Flag locale={l} className="h-4 w-6" />,
  }));

  return (
    <Menu
      label={t('menu.openLanguage')}
      closeLabel={t('a11y.closeMenu')}
      triggerClassName="flex items-center gap-2 rounded-md border border-border bg-surface px-3 py-2 text-sm font-medium text-fg transition-colors hover:bg-surface-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand motion-reduce:transition-none"
      trigger={
        <>
          <Flag locale={locale} className="h-4 w-6" />
          <span>{t(`lang.${locale}`)}</span>
          <ChevronDownIcon className="h-4 w-4 text-muted" aria-hidden="true" />
        </>
      }
      options={options}
      value={locale}
      onSelect={setLocale}
    />
  );
}
